import { render, staticRenderFns } from "./EdificeSectionMobile.vue?vue&type=template&id=36422dbb&scoped=true"
import script from "./EdificeSectionMobile.vue?vue&type=script&lang=js"
export * from "./EdificeSectionMobile.vue?vue&type=script&lang=js"
import style0 from "./EdificeSectionMobile.vue?vue&type=style&index=0&id=36422dbb&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36422dbb",
  null
  
)

export default component.exports